import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveSecondaryCriteriaTemplate,
  useRetrieveResourceDetailsConfiguration,
} from "@planzone/view-models";
import { useRoles } from "@scenes/safeguard";
import { Language } from "@common/language";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourceSecondaryCriteria({ criteriaForms }: Props) {
  const { planzone } = useRetrieveCurrentPlanzone();
  const { template } = useRetrieveSecondaryCriteriaTemplate(
    planzone.uuid,
    "resource",
  );
  const { configuration } = useRetrieveResourceDetailsConfiguration(planzone);
  const roles = useRoles({});
  const profile =
    configuration.find((p) =>
      p.roles.find((role) =>
        roles.find((r) => r.uuid === role || r.name === role),
      ),
    ) || configuration.length > 0
      ? configuration[0]
      : {
          name: "",
          roles: [],
          columns: [],
        };
  const columns = profile.columns.filter(
    ({ key }) =>
      !!template.map(({ uuid }) => uuid).find((criteria) => criteria === key),
  );

  return (
    <Language>
      {({ currentLanguage }) => (
        <div className={styles.secondaryCriteria}>
          {columns.map(({ key }) => {
            const criteria = template.find(({ uuid }) => uuid === key);

            return (
              <div key={key} className={styles.row}>
                <div className={styles.label}>
                  <p>
                    {criteria
                      ? criteria.labels[
                          currentLanguage as keyof typeof criteria.labels
                        ]
                        ? criteria.labels[
                            currentLanguage as keyof typeof criteria.labels
                          ]
                        : criteria.name
                      : key}
                  </p>
                </div>
                <div className={styles.form}>
                  {criteriaForms[key as keyof typeof criteria]}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Language>
  );
}

export { ResourceSecondaryCriteria };
